module.exports = __webpack_public_path__ + "static/tw-trade-curve-fb25954ad6bc69ca758f95a04bd8f6e4.jpg";